// @flow
/* eslint-disable import/prefer-default-export */
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type {
  ExportAnswersDetailProps,
  ExportParams,
  ExportProps,
  ExportResponse,
} from 'types/exports'

export async function getExports(
  { page = 1, pageSize = 10, search }: ExportParams = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<ExportResponse> {
  return await makeGetRequest(
    ApiBase +
      `/exports?page=${page}&page_size=${pageSize}` +
      (search ? `&search=${search}` : ''),
    requestParams
  )
}

export async function getExport({
  id,
}: {
  id: string,
  params?: ExportParams,
}): Promise<ExportProps> {
  const url = `${ApiBase}/exports/${id}`
  return await makeGetRequest(url)
}

export async function getExportAnswers({
  id,
  download,
}: {
  id: string,
  download?: boolean,
}): Promise<ExportAnswersDetailProps | Blob> {
  const url =
    `${ApiBase}/exports/${id}/answers` + (download ? '?type=csv_file' : '')
  return await makeGetRequest(url)
}

export async function getExportResponses({
  id,
  params: { page = 1, pageSize = 10 } = {},
}: {
  id: string,
  params?: ExportParams,
}): Promise<ExportResponse> {
  const url = `${ApiBase}/exports/${id}/responses?page=${page}&page_size=${pageSize}`
  return await makeGetRequest(url)
}
